import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setAnalytics, clearAnalytics } from "../../../store/actions/analyticsActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAnalytics = (bearerAuth, year = 0) => {
  return async dispatch => {
    API.get(`/api/portal/analytics?year=${year}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setAnalytics(response.body));
        } else if (response.status === 401) {
          dispatch(clearAnalytics);
          dispatch(authLogout);
        } else {
          dispatch(clearAnalytics)
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Analytic Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearAnalytics);
      })
  }
}